<!-- Payment component -->
<script>
export default {
  name: "payment"
};
</script>

<!-- Template -->
<template>
  <div>
    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand href="#">Continue Shopping</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto path">
            <b-navbar-nav>
              <b-nav-item href="#" class="path-text" disabled>
                Log In
                <span>></span>
              </b-nav-item>
              <b-nav-item href="#" class="path-text">
                Payment Method
                <span>></span>
              </b-nav-item>
              <b-nav-item href="#" class="path-text" disabled>Confirmation</b-nav-item>
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <!-- <h2 class="page-not-found">Payment</h2> -->
    <b-container class="pt-5">
      <!-- Stack the columns on mobile by making one full-width and the other half-width -->
      <b-row>
        <b-col lg="7" md="7" sm="12">Payment Details</b-col>
        <b-col lg="5" md="5" sm="12" class="right-panel">
          <b-card class="items-card detail-card" sub-title="YOUR ORDER SUMMARY">
            <div class="list-item">
              <div class="item-close">
                <b-icon-x></b-icon-x>
              </div>
              <div>
                <img src="../../../../assets/logo.png" class="item-image" alt />
                <div class="item-details">
                  <span class="item-name">Cross body shopper</span>
                  <span class="item-color">black</span>
                  <span class="item-quantity">Quantity</span>
                </div>
              </div>
            </div>
            <div class="item-cost">
              <span>$1445</span>
            </div>
            <div class="list-item">
              <div class="item-close">
                <b-icon-x></b-icon-x>
              </div>
              <div>
                <img src="../../../../assets/logo.png" class="item-image" alt />
                <div class="item-details">
                  <span class="item-name">Patent court shoes</span>
                  <span class="item-color">black</span>
                  <span class="item-quantity">Quantity</span>
                </div>
              </div>
            </div>
            <div class="item-cost">
              <span>$1445</span>
            </div>
            <div class="subtotal">
              <b-row align-h="end">
                <b-col cols="5">Subtotal</b-col>
                <b-col cols="4">
                  <span>$5552.55</span>
                </b-col>
              </b-row>
              <b-row align-h="end">
                <b-col cols="5">FREE Shipping</b-col>
                <b-col cols="4">
                  <span>$0.00</span>
                </b-col>
              </b-row>
            </div>
            <div class="total">
              <b-row align-h="end">
                <b-col cols="5">Order Total</b-col>
                <b-col cols="4">
                  <span>$10552.55</span>
                </b-col>
              </b-row>
            </div>
          </b-card>
          <b-card class="items-card item-info">
            <div class="item-close pb-2">
              <b-icon-wallet-fill></b-icon-wallet-fill>
              <span class="info-text">free and trusted courier service</span>
            </div>
            <div class="item-close pb-2">
              <b-icon-wallet-fill></b-icon-wallet-fill>
              <span class="info-text">International Shipping</span>
            </div>
            <div class="item-close pb-2">
              <b-icon-wallet-fill></b-icon-wallet-fill>
              <span class="info-text">Return up to 30 days</span>
            </div>
            <div class="item-close pb-2">
              <b-icon-wallet-fill></b-icon-wallet-fill>
              <span class="info-text">Secure payment</span>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<!-- Style -->
<style lang="scss">
.page-not-found {
  text-align: center;
  margin-top: 24px;
  font-weight: 500;
  color: #888888;
}
.path span {
  padding-left: 10px;
}

.path-text .nav-link {
  color: lightgray !important;
}
.path-text .nav-link:hover {
  color: white !important;
}
.right-panel {
  min-height: 500px;
  padding-left: 50px;
  border-left: 1px solid lightgrey;
}

.list-item {
  display: inline-block;
  width: 100%;
  padding: 10px 0 0 10px;
  min-height: 70px;
}

.list-item div {
  display: inline-block;
}
.item-name {
  display: block;
  font-size: 15px;
  line-height: 1;
  font-weight: bold;
}

.item-close {
  vertical-align: top;
  padding-top: 10px;
  cursor: pointer;
}
.item-color {
  display: block;
  color: lightgray;
  line-height: 1;
}

.item-quantity {
  display: block;
  color: lightgray;
  font-size: 15px;
  line-height: 1;
}

.item-image {
  width: 40px;
  height: 40px;
  margin-left: 10px;
  vertical-align: baseline;
}

.item-details {
  padding-left: 10px;
}

.item-cost {
  width: 100%;
  display: block;
}

.item-cost span {
  float: right;
}

.subtotal {
  display: block;
  width: 100%;
  padding-top: 50px;
}

.total {
  display: block;
  width: 100%;
  padding-top: 30px;
}

.subtotal span {
  float: right;
}
.total span {
  float: right;
}

.item-info {
  margin-top: 20px;
  background-color: #e6e6e6;
  border: none;
}

.info-text {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 12px;
  padding-left: 20px;
}

.detail-card {
  border: 1px solid black;
}
</style>
